'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _Helper = require('./Helper');

var _lodashCompat = require('lodash-compat');

var _lodashCompat2 = _interopRequireDefault(_lodashCompat);

var _parse = require('./parse');

var _parse2 = _interopRequireDefault(_parse);

var _input = require('../input');

var _input2 = _interopRequireDefault(_input);

var _datePicker = require('../date-picker');

var _select = require('../select');

var _select2 = _interopRequireDefault(_select);

var _treeSelect = require('../tree-select');

var _treeSelect2 = _interopRequireDefault(_treeSelect);

var _checkbox = require('../checkbox');

var _upload = require('../upload');

var _upload2 = _interopRequireDefault(_upload);

var _radio = require('../radio');

var _util = require('./util');

var _data = require('../util/data');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
    var resolver = this;

    if (catcher === true) {
        if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
            var _tasks = [];

            if (!tick) {
                try {
                    tick = process.nextTick;
                } catch (ex) {
                    tick = function tick(p) {
                        setTimeout(p, 0);
                    };
                }
            }

            function _untask() {
                for (var i = 0; i < _tasks.length; i += 2) {
                    var t = _tasks[i + 1],
                        r = _tasks[i];

                    for (var j = 0; j < t.length; j++) {
                        t[j].call(null, r);
                    }
                }

                _tasks = [];
            }

            function isThenable(obj) {
                return obj && obj instanceof Object && typeof obj.then === 'function';
            }

            function EagerThenable(resolver) {
                function done(inline) {
                    var w;
                    if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

                    _tasks.push(result, w);

                    _thens = [[], []];
                    if (_tasks.length === 2) inline ? _untask() : tick(_untask);
                }

                function resolveThen(x) {
                    if (isThenable(x)) return x.then(resolveThen, rejectThen);
                    phase = 0;
                    result = x;
                    done(true);
                }

                function rejectThen(x) {
                    if (isThenable(x)) return x.then(resolveThen, rejectThen);
                    phase = 1;
                    result = x;
                    done(true);
                }

                function settler(resolver, rejecter) {
                    _thens[0].push(resolver);

                    _thens[1].push(rejecter);

                    done();
                }

                function toString() {
                    return 'EagerThenable{' + {
                        '-1': 'pending',
                        0: 'resolved',
                        1: 'rejected'
                    }[phase] + '}=' + result.toString();
                }

                this.then = settler;
                this.toString = toString;
                var _thens = [[], []],
                    _sync = true,
                    phase = -1,
                    result;
                resolver.call(null, resolveThen, rejectThen);
                _sync = false;
                done();
            }

            EagerThenable.resolve = function (v) {
                return isThenable(v) ? v : {
                    then: function then(resolve, reject) {
                        return resolve(v);
                    }
                };
            };

            return EagerThenable;
        }();
        return new Function.prototype.$asyncbind.EagerThenable(boundThen);
    }

    if (catcher) {
        if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
        return then;
    }

    function then(result, error) {
        try {
            return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
        } catch (ex) {
            return (error || catcher)(ex);
        }
    }

    function boundThen(result, error) {
        return resolver.call(self, result, error);
    }

    boundThen.then = boundThen;
    return boundThen;
};
//类型支持的组件


// TODO TREE

/**
 * 把属性绑定上来
 */
function bindProps(state, list) {
    var props = {};
    _lodashCompat2.default.forEach(list, function (prop) {
        if (state.hasOwnProperty(prop)) {
            props[prop] = state[prop];
        }
    });
    return props;
}

function deleteProps(state, list) {
    var props = _lodashCompat2.default.cloneDeep(state);
    _lodashCompat2.default.forEach(list, function (prop) {
        if (props.hasOwnProperty(prop)) {
            delete props[prop];
        }
    });
    return props;
}

/**
 *  bill的字段组件
 *  传入的参数如下:
 *  model
 *  alignment
 *  actions
 *  onFetchData
 *  onChange
 *  parent
 *  传入model 后续的修改不外乎几种
 *  1 赋值
 *  2 编辑状态改变
 *  3 显示状态改变
 *  4 显示状态改变
 *
 */

var BillItem = (0, _createReactClass2.default)({
    initialed: false,
    shouldComponentUpdate: function shouldComponentUpdate(props, state) {
        return this.state !== state;
    },
    getDefaultProps: function getDefaultProps() {
        return {
            //
            //name: "", //label的值
            //code: "",
            //mode: "default",//显示的模式 default-->默认模式  view-->为只显示模式
            //readonly: false,
            //conf: {},//包含 showHeader(是否显示头) alignment(排列方式) required(是否必填项) trigger:"onChange"||"onBlur"
            //type: "",
            //required: false,
            //alignment: ALIGNMENT.right,
            //tooltip: ""
        };
    },
    /**
     * 对传入的model进行拆分 进行parse
     *
     */
    getInitialState: function getInitialState() {
        return this.init(this.props);
    },
    labelElement: function labelElement(props) {
        var Label = this.state.label;
        //控制不显示头
        if ((0, _data.isEmptyString)(Label) || this.state.showHeader == false) {
            return null;
        }
        return _react2.default.createElement(
            'label',
            { className: 'bill-item-label' },
            (0, _data.getComponent)(Label, props)
        );
    },
    contentElement: function contentElement() {
        var content,
            props = deleteProps(this.state, ['code', 'label', 'type', 'addonBefore', 'addonAfter', 'show', 'full', 'showHeader', 'alignment']),
            cls = "bill-item-content";
        switch (this.state.type) {
            case "text":
            case "password":
            case "number":
                content = _react2.default.createElement(_input2.default, _extends({ className: cls, ref: 'element', type: this.state.type,
                    onFocus: this.state.onFocus,
                    onBlur: this.state.onBlur,
                    onClear: this.state.onClear,
                    onChange: this.state.onChange }, props));
                break;
            case "textarea":
                content = _react2.default.createElement(_input2.default, _extends({ className: cls, ref: 'element', type: 'textarea',
                    onFocus: this.state.onFocus,
                    onBlur: this.state.onBlur,
                    onClear: this.state.onClear,
                    onChange: this.state.onChange }, props));
                break;
            case "time":
                content = _react2.default.createElement(_datePicker.TimePicker, _extends({ className: cls, ref: 'element',
                    getPopupContainer: this.state.getPopupContainer,
                    onChange: this.state.onChange }, props));
                break;
            case "date":
                content = _react2.default.createElement(_datePicker.DatePicker, _extends({ className: cls, ref: 'element',
                    getPopupContainer: this.state.getPopupContainer,
                    onChange: this.state.onChange }, props));
                break;
            case "rangeDate":
                content = _react2.default.createElement(_datePicker.RangePicker, _extends({ type: 'range', className: cls, ref: 'element',
                    getPopupContainer: this.state.getPopupContainer,
                    onChange: this.state.onChange }, props));
                break;
            case 'autoText':
                content = _react2.default.createElement(_select2.default, _extends({ className: cls, ref: 'element', combobox: true,
                    getPopupContainer: this.state.getPopupContainer,
                    onFetchData: this.state.onFetchData,
                    onFocus: this.state.onFocus,
                    onBlur: this.state.onBlur,
                    onSelect: this.state.onSelect,
                    onSearch: this.state.onSearch,
                    onClear: this.state.onClear,
                    onKeyDown: this.state.onKeyDown,
                    onChange: this.state.onChange }, props));
                break;
            case "select":
                content = _react2.default.createElement(_select2.default, _extends({ className: cls, ref: 'element',
                    getPopupContainer: this.state.getPopupContainer,
                    onFetchData: this.state.onFetchData,
                    onFocus: this.state.onFocus,
                    onBlur: this.state.onBlur,
                    onSelect: this.state.onSelect,
                    onSearch: this.state.onSearch,
                    onClear: this.state.onClear,
                    onKeyDown: this.state.onKeyDown,
                    onChange: this.state.onChange }, props));
                break;
            case "multiSelect":
                content = _react2.default.createElement(_select2.default, _extends({ className: cls, multiple: true, ref: 'element',
                    getPopupContainer: this.state.getPopupContainer,
                    onFetchData: this.state.onFetchData,
                    onFocus: this.state.onFocus,
                    onBlur: this.state.onBlur,
                    onSelect: this.state.onSelect,
                    onDeSelect: this.state.onDeSelect,
                    onSearch: this.state.onSearch,
                    onClear: this.state.onClear,
                    onKeyDown: this.state.onKeyDown,
                    onChange: this.state.onChange }, props));
                break;
            case "treeSelect":
                content = _react2.default.createElement(_treeSelect2.default, _extends({ className: cls, ref: 'element',
                    getPopupContainer: this.state.getPopupContainer,
                    onFetchData: this.state.onFetchData,
                    onFetchNodeData: this.state.onFetchNodeData,
                    onFocus: this.state.onFocus,
                    onBlur: this.state.onBlur,
                    onSelect: this.state.onSelect,
                    onSearch: this.state.onSearch,
                    onClear: this.state.onClear,
                    onKeyDown: this.state.onKeyDown,
                    onChange: this.state.onChange }, props));
                break;
            case "treeMultiSelect":
                content = _react2.default.createElement(_treeSelect2.default, _extends({ className: cls, multiple: true, ref: 'element',
                    getPopupContainer: this.state.getPopupContainer,
                    onFetchData: this.state.onFetchData,
                    onFetchNodeData: this.state.onFetchNodeData,
                    onFocus: this.state.onFocus,
                    onBlur: this.state.onBlur,
                    onSelect: this.state.onSelect,
                    onDeSelect: this.state.onDeSelect,
                    onSearch: this.state.onSearch,
                    onClear: this.state.onClear,
                    onKeyDown: this.state.onKeyDown,
                    onChange: this.state.onChange }, props));
                break;
            case "radio":
                content = _react2.default.createElement(_radio.RadioGroup, _extends({ className: cls, ref: 'element',
                    onChange: this.state.onChange }, props));
                break;
            case "checkbox":
                content = _react2.default.createElement(_checkbox.CheckboxGroup, _extends({ className: cls, ref: 'element',
                    onChange: this.state.onChange }, props));
                break;
            case "upload":
                content = _react2.default.createElement(_upload2.default, _extends({ className: cls, ref: 'element',
                    onUpload: this.state.onUpload,
                    onBeforeUpload: this.state.onBeforeUpload,
                    onBeforeUploadAll: this.state.onBeforeUploadAll,
                    onError: this.state.onError,
                    onSuccess: this.state.onSuccess,
                    onDelete: this.state.onDelete,
                    onChange: this.state.onChange }, props));
                break;
            case "ref":
                break;
            case "slave":
                break;
        }
        return content;
    },
    /**
     * 初始化model
     */
    init: function init(props) {
        var state, model;
        if (!_lodashCompat2.default.isEmpty(props.model)) {
            model = props.model;
            this.bill = props.parent;
            this.initialed = true;
            //不同类型来个不同的解析吧
            state = _parse2.default.parseModel(model, props.actions, this.bill);
            state.actions = props.actions;
            state.size = state.size || props.size;
            state.alignment = _Helper.ALIGNMENT[state.alignment || props.alignment] || _Helper.ALIGNMENT.right;
            state.prefixCls = state.prefixCls || props.prefixCls;
            props.mode === 'view' && (state.mode = 'view');
            state.onChange = props.onChange;
            props.getPopupContainer && (state.getPopupContainer = props.getPopupContainer);
            props.onUpload && (state.onUpload = props.onUpload);
            props.onFetchData && (state.onFetchData = props.onFetchData);
            props.onFetchNodeData && (state.onFetchNodeData = props.onFetchNodeData);
        }
        return state;
    },
    /*
     * 同理只认第一次传入的model
     */
    componentWillReceiveProps: function componentWillReceiveProps(props) {
        if (!this.initialed) {
            var state = this.init(props);
            this.setState(state);
        }
    },
    render: function render() {
        if (!this.initialed) {
            return null;
        }
        if (!this.state.show) {
            return null;
        }
        var className = this.props.prefixCls + '-bill-item ' + this.props.prefixCls + '-bill-item-' + this.state.type,
            alignment = this.state.alignment;
        //对齐方式
        className = className + " alignment-" + alignment;
        //只读
        if (this.props.readonly) {
            className = className + " readonly";
        }
        //必填
        if (this.state.required) {
            className = className + " required";
        }
        //只显示
        if (this.state.mode == "view") {
            className = className + " mode-view";
        }
        if (this.props.className) {
            className += " " + this.props.className;
        }
        if (this.state.full) {
            className += " bill-item-group-full";
        } else if (this.state.type == "textarea" && this.state.full !== false) {
            className += " bill-item-group-full";
        } else if (this.state.type == "upload" && this.state.full !== false) {
            className += " bill-item-group-full";
        }
        var AddonBefore = this.state.addonBefore;
        var AddonAfter = this.state.addonAfter;
        var props = {
            bill: this.props.parent,
            value: this.state.value,
            model: this.props.model
        };
        return _react2.default.createElement(
            'div',
            { className: className },
            _react2.default.createElement(
                'div',
                { className: 'bill-item-group' },
                this.labelElement(props),
                _react2.default.createElement(
                    'div',
                    { className: "bill-item-element" + (AddonBefore || AddonAfter ? " bill-item-element-addon" : "") },
                    AddonBefore && _react2.default.createElement(
                        'div',
                        { className: 'bill-item-addon-before' },
                        (0, _data.getComponent)(AddonBefore, props)
                    ),
                    this.contentElement(),
                    AddonAfter && _react2.default.createElement(
                        'div',
                        { className: 'bill-item-addon-after' },
                        (0, _data.getComponent)(AddonAfter, props)
                    )
                )
            )
        );
    },
    /**
     * 被外部赋值过来
     */
    setValue: function setValue(value) {
        var self = this;
        // 第一步 赋值
        this.setState({ value: value }, function () {
            var fetchEvent = self.bill.fetchs[self.state.code],
                controlEvent = self.bill.controls[self.state.code];
            // 第二步 fetch 判断本身是否有fetch 需不需要触发fetch
            if (fetchEvent && fetchEvent.auto) {
                //去获取数据 然后赋值
                self.parent.doFetchHandler(self.props.model, fetchEvent);
            }
            // 第三步 control 判断本身是否有control 触发control
            if (controlEvent) {
                //解析control
                self.bill.doControlHandler(self.state.code, self.bill.getData()[self.state.code], controlEvent);
            }
        });
    },
    /**
     * 获取数据
     */
    getValue: function getValue() {
        return (0, _data.getSafetyString)(this.state.value);
    },
    /**
     * 清空其他zhuangtai
     */
    clear: function clear() {
        if (this.refs.element && this.refs.element.clear) {
            this.refs.element.clear();
        }
    },
    /**
     * 重置组件的状态
     */
    reset: function reset() {
        this.setState({ value: "" });
        if (this.refs.element && this.refs.element.reset) {
            this.refs.element.reset();
        }
    },
    /**
     * 清空下拉数据  下次展开时会再去请求数据
     */
    clearOption: function clearOption() {
        if (this.refs.element && this.refs.element.clearOption) {
            this.refs.element.clearOption();
        }
    },
    /**
     * 校验
     */
    validate: function validate() {
        if (this.refs.element && this.refs.element.validate) {
            return this.refs.element.validate();
        }
        return true;
    },
    /**
     * 变更显示
     * @param model 更新state
     */
    updateModel: function updateModel(model) {
        if (!_lodashCompat2.default.isEmpty(model)) {
            var state = this.init(Object.assign({}, this.props, { model: Object.assign({}, this.props.model, model) }));
            this.setState(state);
        }
    }
});

module.exports = BillItem;